export default "__VITE_ASSET__3a26fee3__"